export default {
    methods: {
        getSchema() {
            return {
                "logic_op": "AND",
                "rules": [
                    {key: '', op: '', value: ''}
                ]
            }
        }
    }
}
